import {Injectable} from '@angular/core';
import * as moment from 'moment';
import appUtil from '../../util/app.util';
@Injectable({
  providedIn: 'root',
})
export class DateService {
  moment(date?: Date | string, format?: string): moment.Moment {
    if (appUtil.isEmpty(format)) {
      return moment(date ?? new Date());
    }
    return moment(date ?? new Date(), format);
  }
}
